import mABCardArray from "../../utils/mABCardArray";
import MABCard from "../../components/MABCard/MABCard";
import "../MembersAdvisoryBoard/MembersAdvisoryBoard.css";
import { useEffect } from "react";

const MembersAdvisoryBoard: React.FC = () => {
  useEffect(() => {
    document.title = "CEO.CA | Member Advisory Board";
  }, []);

  return (
    <div className="members-body">
      <div className="members-jumbotron">
        <a href="https://ceo.ca">
          <img
            src={require("../../assets/logo.png")}
            alt="logo"
            className="logo"
          />
        </a>
        <div className="members-hero">
          <h1 className="members-title">CEO.CA Member Advisory Board</h1>
          <h4 className="members-header">
            We believe that our Member Advisory Board, with their diverse
            backgrounds, are essential to the future of CEO.CA. With their ample
            experience and network, they provide unique and effective insight
            into what our users are looking for.
          </h4>
        </div>
      </div>
      <div className="members-container">
        {mABCardArray.map((item, key) => {
          return <MABCard item={item} key={key} />;
        })}
      </div>
      <div className="members-question-container">
        <h1 style={{ color: "#900" }}>Looking to join our MAB?</h1>
        <p>
          Help shape the future of CEO.CA as a Advisory Board Member. Board
          Members work with executives of CEO.CA throughout the year to make
          community driven recommendations on new tools and resources,
          committing to a one year term.
        </p>
        <h4>
          Stay tuned for more information on how you can apply to be a part of
          our next Member Advisory Board.
        </h4>
      </div>
      <div className="members-footer">
        <a href="https://ceo.ca">
          <img
            src={require("../../assets/logo.png")}
            alt="logo"
            className="logo-footer"
          />
        </a>
        <a href="/" style={{ textDecoration: "none" }}>
          <h4 className="footer-link">Help Desk</h4>
        </a>
        <a href="/member-advisory-board" style={{ textDecoration: "none" }}>
          <h4 className="footer-link">Member Advisory Board</h4>
        </a>
        <p className="footer-text">© {new Date().getFullYear()} - CEO.CA Technologies Ltd.</p>
      </div>
    </div>
  );
};

export default MembersAdvisoryBoard;
